import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'discount',
    standalone: false
})
export class DiscountPipe implements PipeTransform {
  transform(value: number, discount: number): number {

    return (value * (1 - discount/100));
  }
}
